import { render, staticRenderFns } from "./saveFilter.vue?vue&type=template&id=324a210a&scoped=true"
import script from "./saveFilter.vue?vue&type=script&lang=js"
export * from "./saveFilter.vue?vue&type=script&lang=js"
import style0 from "./saveFilter.vue?vue&type=style&index=0&id=324a210a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324a210a",
  null
  
)

export default component.exports